"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLabel = void 0;
exports["default"] = CuriousPandaField;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.split.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.array.concat.js");
var _reactFinalForm = require("react-final-form");
var _react = _interopRequireWildcard(require("react"));
var _validations = require("./validations");
var _lodash = _interopRequireDefault(require("lodash"));
var _fieldsLegacy = _interopRequireDefault(require("./fieldsLegacy"));
var _fields = _interopRequireDefault(require("./fields"));
var _fieldStatic = _interopRequireWildcard(require("./fieldStatic"));
var _fieldsArray = _interopRequireWildcard(require("./fieldsArray"));
var _utils = require("./utils");
var _excluded = ["interface", "smallLabel", "description", "question_description", "title", "labelStyle", "inputStyle", "options", "config", "fieldSpacing", "collapseable", "nowDate", "name", "condition", "showValidationWithoutTouch"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var createLabel = exports.createLabel = function createLabel(_ref) {
  var label = _ref.label,
    name = _ref.name,
    values = _ref.values;
  if (_lodash["default"].isFunction(label)) {
    return label(name.split('.'), {
      values: values
    });
  } else {
    return label;
  }
};
function CuriousPandaField(props) {
  var _FieldDictionary$intf, _FieldDictionary$intf2, _FieldDictionary$intf3;
  var intf = props["interface"],
    smallLabel = props.smallLabel,
    description = props.description,
    question_description = props.question_description,
    title = props.title,
    labelStyle = props.labelStyle,
    inputStyle = props.inputStyle,
    options = props.options,
    _props$config = props.config,
    config = _props$config === void 0 ? {} : _props$config,
    fieldSpacing = props.fieldSpacing,
    collapseable = props.collapseable,
    nowDate = props.nowDate,
    name = props.name,
    condition = props.condition,
    showValidationWithoutTouch = props.showValidationWithoutTouch,
    restProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var form = (0, _reactFinalForm.useForm)();
  var validate = _utils.composeValidators.apply(void 0, (0, _toConsumableArray2["default"])(props.validate || []));
  var values = form.getState().values;
  var label = createLabel({
    name: props.name,
    label: props.label,
    values: values
  });
  var componentValidations = (_FieldDictionary$intf = _fields["default"][intf]) !== null && _FieldDictionary$intf !== void 0 && _FieldDictionary$intf.validations ? _fields["default"][intf].validations(props) : [];

  // checking if we have a conditional set up for this field
  var shouldRender = true;
  if (condition) {
    shouldRender = !!condition(name.split('.'), {
      values: values
    });
  }
  (0, _react.useEffect)(function () {
    if (showValidationWithoutTouch && shouldRender) {
      form.mutators.setFieldTouched(name, true);
    }
  }, [form.mutators, name, shouldRender, showValidationWithoutTouch]);
  if (!shouldRender) {
    return null;
  }

  // Static Fields
  if (_fieldStatic.StaticFields.includes(intf)) {
    return /*#__PURE__*/_react["default"].createElement(_fieldStatic["default"], (0, _extends2["default"])({}, _lodash["default"].pick(props, ['interface', 'name', 'onClick', 'buttonStyle', 'disabled', 'content']), {
      label: label || smallLabel
    }));
  }

  // Array
  if (_fieldsArray.ArrayFields.includes(intf)) {
    return /*#__PURE__*/_react["default"].createElement(_fieldsArray["default"], props);
  }

  // Field Dictionary
  if ((_FieldDictionary$intf2 = _fields["default"][intf]) !== null && _FieldDictionary$intf2 !== void 0 && _FieldDictionary$intf2.component) {
    var DictionaryComponent = _fields["default"][intf].component;
    var fieldValidations = [validate];
    if (restProps.required) {
      fieldValidations.push(_validations.required);
    }
    fieldValidations = fieldValidations.concat(componentValidations);
    var composedValidator = _utils.composeValidators.apply(void 0, (0, _toConsumableArray2["default"])(fieldValidations));
    return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, (0, _extends2["default"])({}, _lodash["default"].omit(props, 'submitting', 'dispatch', 'inputs', 'components', 'stateFromRedux', 'dispatch', 'condition', 'displayMessage', 'remoteSubmit'), {
      submitting: props.submitting,
      inputStyle: inputStyle,
      labelStyle: labelStyle,
      label: label || smallLabel,
      component: DictionaryComponent,
      validate: composedValidator,
      config: _objectSpread(_objectSpread({}, props), config)
    }));
  }
  if ((_FieldDictionary$intf3 = _fields["default"][intf]) !== null && _FieldDictionary$intf3 !== void 0 && _FieldDictionary$intf3.field) {
    var Component = _fields["default"][intf].field;
    return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, props, {
      validate: validate
    }));
  }

  // here be dragons
  return /*#__PURE__*/_react["default"].createElement(_fieldsLegacy["default"], _lodash["default"].omit(props, 'submitting', 'dispatch', 'inputs', 'stateFromRedux', 'dispatch', 'condition', 'displayMessage', 'remoteSubmit'));
}